import React, { useEffect, useRef, useState } from "react";
import { Spin, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";

import "./Questions.scss";
import { PAGE_SIZE } from "../../constants";
import { exportShippers, fetchShippers } from "../../actions/shipper";
import { fetchAdmins } from "../../actions/admin";
import ShippersTable from "../Tables/Shippers";
import ShippersFilterForm from "../Forms/ShippersFilter";
import moment from "moment";
import { CSVLink } from "react-csv";
import { resetDownloadCsv } from "../../actions/survey";

const ShippersPage = () => {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const { shippers, status, loading } = useSelector(
		(state) => state.fetchShippers,
	);

	const { admins } = useSelector((state) => state.fetchAdmins);
	const { file } = useSelector((state) => state.exportShippers);
	const csvLink = useRef();

	const [adminsList, setAdminsList] = useState();
	const [pagination, setPagination] = useState({});
	const [currentPage, setCurrentPage] = useState(1);
	const limit = Number(PAGE_SIZE) || 20;

	const [isExportClick, setIsExportClick] = useState(false);
	const [csvFile, setCsvFile] = useState("");

	const handleFilter = (params) => {
		setCurrentPage(params.page);
		const startAt = (params.page - 1) * Number(PAGE_SIZE);
		dispatch(fetchShippers({ start: Number(startAt), count: PAGE_SIZE }));
	};

	const handleTableChange = (params) => {
		handleFilter(params);
	};

	useEffect(() => {
		dispatch(fetchShippers({ start: 0, count: PAGE_SIZE }));
		dispatch(fetchAdmins({}));
	}, []);

	useEffect(() => {
		if (admins) {
			const shipperAdmins = admins.data.filter(
				(admin) => admin.role === "shipper",
			);
			setAdminsList(shipperAdmins);
		}
	}, [admins]);

	useEffect(() => {
		if (shippers) {
			setPagination({
				showSizeChanger: false,
				current: currentPage,
				pageSize: limit,
				total: shippers.total,
				showTotal: (total) => `${total} Items`,
			});
		}
	}, [shippers]);

	const filterSubmit = (values) => {
		const newValues = { ...values };
		newValues.from = newValues?.date_range
			? moment(newValues?.date_range[0]).format("YYYY-MM-DD")
			: null;
		newValues.to = newValues?.date_range
			? moment(newValues?.date_range[1]).format("YYYY-MM-DD")
			: null;
		delete newValues.date_range;
		if (!isExportClick) {
			if (newValues && newValues !== "") {
				dispatch(
					fetchShippers({
						start: 0,
						count: PAGE_SIZE,
						filter: newValues,
					}),
				);
			} else {
				dispatch(fetchShippers({ start: 0, count: PAGE_SIZE }));
			}
		} else {
			delete newValues.orderId;
			delete newValues.adminId;
			dispatch(exportShippers({ filter: newValues }));
			setIsExportClick(false);
		}
	};

	const resetForm = () => {
		form.resetFields();
		dispatch(fetchShippers({ start: 0, count: PAGE_SIZE }));
	};

	const onExportShippersClick = () => {
		setIsExportClick(true);
		form.submit();
	};

	useEffect(() => {
		if (file) {
			setCsvFile(file);
			dispatch(resetDownloadCsv());
			setTimeout(() => {
				csvLink.current.link.click();
			});
		}
	}, [file]);

	return (
		<Spin spinning={loading} tip="Loading ...">
			<div className="shippers-container">
				<div className="page-header">
					<div className="page-header-breadbrumb">
						<ul>
							<li>Shipping Labels</li>
						</ul>
					</div>
				</div>
				<div className="page-filter">
					<CSVLink
						data={csvFile}
						filename={`eys-surveys-export-shipping-labels.csv`}
						className="hidden"
						ref={csvLink}
						target="_blank"
					/>
					<ShippersFilterForm
						form={form}
						filterSubmit={filterSubmit}
						resetForm={resetForm}
						admins={adminsList}
						onExportShippersClick={onExportShippersClick}
					/>
				</div>
				<div className="page-content">
					{status === "SUCCEEDED" && (
						<ShippersTable
							rowKey="id"
							pagination={pagination}
							onChange2={handleTableChange}
							dataSource={shippers.data}
							scrollHeight="calc(100vh - 275px)"
							actionWidth={150}
						/>
					)}
				</div>
			</div>
		</Spin>
	);
};

export default ShippersPage;
